var map = {
	"./son10_active.png": "c5a9",
	"./son11_active.png": "f77d",
	"./son12_active.png": "b0f8",
	"./son13_active.png": "b468",
	"./son1_active.png": "377a",
	"./son2_active.png": "b47d",
	"./son3_active.png": "9d96",
	"./son4_active.png": "d93e",
	"./son5_active.png": "a373",
	"./son6_active.png": "9c17",
	"./son7_active.png": "812c",
	"./son8_active.png": "e907",
	"./son9_active.png": "77ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dc7c";